import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {
    ActionCardImage,
    GraphicalActionCard,
    LinkWithAttribution,
} from '../../../../../../components';

export function CardiovascularDiseaseWeight(props) {
    const {currentStep, totalSteps} = props;

    const intl = useIntl();

    return (
        <GraphicalActionCard
            currentStep={currentStep}
            dataTestId={'weight-CVD_US'}
            headerImage={ActionCardImage.WEIGHT}
            title={intl.formatMessage({id: 'reports.trait.lifestyleActions.weight.title'})}
            totalSteps={totalSteps}
        >
            <p>
                <FormattedMessage
                    id={'reports.trait.lifestyleActions.weight.description.one.CVD_US'}
                />
            </p>
            <p>
                <FormattedMessage
                    id={'reports.trait.lifestyleActions.weight.description.two.CVD_US'}
                />
            </p>
            <p>
                <FormattedMessage id={'reports.trait.lifestyleActions.weight.description.three'} />
            </p>
            <LinkWithAttribution
                attribution={intl.formatMessage({id: 'common.link.attribution.AHA'})}
                url={'https://www.heart.org/en/healthy-living/healthy-eating/losing-weight/keeping-a-healthy-body-weight'}
            >
                <FormattedMessage id={'reports.trait.lifestyleActions.weight.link.keep'} />
            </LinkWithAttribution>
        </GraphicalActionCard>
    );
}
